export const SdkBookButtonClicked = 'SDK book button clicked';
